import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://travel-agency-backend-travel.onrender.com/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const tourService = {
  // Get all tours
  getAllTours: async () => {
    try {
      const response = await api.get('/tours');
      return response.data;
    } catch (error) {
      console.error('Error fetching all tours:', error);
      throw error;
    }
  },

  // Get tours by category
  getToursByCategory: async (category) => {
    try {
      const response = await api.get(`/tours/${category}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching ${category} tours:`, error);
      throw error;
    }
  },

  // Search tours
  searchTours: async (query) => {
    try {
      const response = await api.get('/tours/search', {
        params: { q: query }
      });
      return response.data;
    } catch (error) {
      console.error('Error searching tours:', error);
      throw error;
    }
  },

  // Get single tour details
  getTourById: async (id) => {
    try {
      const response = await api.get(`/tour/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching tour ${id}:`, error);
      throw error;
    }
  },
};

export default api;
